<template lang='pug'>
  //- todo
  el-card.io-info(v-loading="loading")
    .card-title
      p {{ $t('IO信息') }}
      el-button(
        v-if="isOpen && !ioForm.is_bypass"
        @click="handleClick"
        type="text"
      ) {{ $t('暂无IO号') }}
    hr.divider
    template(
      v-if="isOpen"
    )
      el-form(
        ref="form"
        :model="ioForm"
      )
        el-form-item.media-form__container(
          v-for="(media_type, i) in ioForm.media_type"
          :key="i"
        )
          p.io-form__title {{ $t('媒体形式') }} {{ i + 1 }}
          el-row.title-row(:gutter="20")
            el-col(
              style="width: 180px"
            ) {{ $t('媒体形式') }}
          el-row.content-row(:gutter="20")
            el-col(:span="10") {{ media_type.media_type_category_name }}
          div(
            v-for="(item,index) in ioForm.media_type[i].media_type_io"
          )
            .media-form__io__container
              el-form-item.io-input-form(
                v-for="(v, idx) in ioForm.media_type[i].media_type_io[index].media_type_io_rel"
                :label="$t('IO号')"
                :key="idx"
                :prop="'media_type[' + i + '].media_type_io[' + index + '].media_type_io_rel['+ idx +'].io'"
                :rules="{ required: true, validator: validateIO,  trigger: 'change' }"
              )
                span {{ getIONumberPrefix(media_type.media_type_category_name) }}
                el-input(
                  style="width: 360px"
                  v-model="v.io"
                )
                el-button.delete-io_btn.delete-io-num_btn(
                  style="margin-left: 5px；margin-bottom:0"
                  v-if="idx!== 0"
                  type="text"
                  @click="handleDeleteIONumber(i, index,idx)"
                ) {{ $t('删除') }}
              //- div(
              //-   style="display:flex;justify-content: flex-end;width: 692px;height: 40px"
              //- )
              el-button.add-io_btn(
                plain
                @click="handleAddIO(i,index)"
                icon="el-icon-circle-plus"
              ) {{ $t('添加IO') }}
              el-form-item(
                :label="$t('IO附件')"
                :prop="'media_type[' + i + '].media_type_io[' + index + '].io_file_path'"
                :rules="{required:true,message: $t('请上传IO附件')}"
              )
                div(style="display:flex")
                  new-upload-file(
                    style="margin-right: 10px"
                    axiosUrl="/management/subfinal/saveFile"
                    :params="{file_type: 22}"
                    @loadingChange="status => loading = status"
                    @uploadSuccess="(res) => uploadSuccess(res, item)"
                  )
                  uploaded-file-display(
                    :fileName="item.io_file_name"
                    :downloadUrl="item.io_download_url"
                    :fileNameList="item.io_file_name_list"
                  )
            div(
              style="display:flex;justify-content: flex-end;width: 696px;height: 40px"
            )
              el-button.delete-io_btn(
                v-if="index !== 0"
                  type="text"
                  @click="handleDeleteIO(i, index)"
                ) {{ $t('删除') }}
          div(
              style="display:flex;justify-content: flex-end;width: 692px;height: 40px"
            )
            el-button.add-io_btn(
              plain
              @click="handleAddIOFile(i)"
              icon="el-icon-circle-plus"
            ) {{ $t('添加IO附件') }}
      el-row(
        :gutter="20"
      )
        el-col(
          :span="10"
          style="margin-left: 550px"
        )
          footer-button(
            @confirm="onSubmit"
            @cancel="onCancel"
          )
    template(
      v-else
    )
      span(
        v-if="!ioForm.is_sow_io"
      ) {{ $t('暂无IO号') }}
      template(
        v-else
      )
        .media-form__container(
          v-for="(media_type, i) in ioForm.media_type"
          :key="i"
        )
          p.io-form__title {{ $t('媒体形式') }} {{ i + 1 }}
          el-row.title-row(:gutter="20")
            el-col(
              style="width: 180px"
            ) {{ $t('媒体形式') }}
          el-row.content-row(:gutter="20")
            el-col(:span="10") {{ media_type.media_type_category_name }}
          div(
            v-for="(item,index) in ioForm.media_type[i].media_type_io"
          )
            .media-form__io__container
              el-row(
                v-for="(v, idx) in item.media_type_io_rel"
                :gutter="20"
                :key="idx"
              )
                el-col(
                  style="width: 180px"
                ) {{ $t('IO号') }}
                el-col(
                  :span="10"
                ) {{ v.io }}
              el-row(
                :gutter="20"
              )
                el-col(
                  style="width: 180px"
                ) {{ $t('IO附件') }}
                el-col(
                  :span="10"
                )
                  a(
                    :href="item.io_download_url"
                  ) {{ item.io_file_name }}
</template>

<script>
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import FooterButton from '@/components/FooterButton'
import axios from 'axios'
import _ from 'lodash'
import { format4backend } from '@/umcc/util'
import { getIONumber } from '@/umcc/constant'

export default {
  components: {
    NewUploadFile,
    UploadedFileDisplay,
    FooterButton
  },
  data () {
    return {
      loading: false,
      ioForm: {
        is_sow_io: 1,
        media_type: [
          {
            media_type_io: [
              {
                media_type_id: null,
                media_type_io_rel: [
                  {
                    io: null
                  }
                ],
                io_file_path: null
              }
            ]
          }
        ]
      }
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    },
    ECTab () {
      return this.$store.state.campaign.ECTab
    },
    isOpen () {
      if (this.ECTab == null || this.ECTab.filter(i => i.tab_name === 'tab_io').length === 0) return false
      const res = this.$store.state.campaign.ECTab.filter(i => i.tab_name === 'tab_io')
      return res[0].is_open
    },
    taskId () {
      if (this.ECTab == null || this.ECTab.filter(i => i.tab_name === 'tab_io').length === 0) return null
      const res = this.$store.state.campaign.ECTab.filter(i => i.tab_name === 'tab_io')
      return res[0].task_id
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    }
  },
  async mounted () {
    this.loading = true
    if (this.$store.state.campaign.ECTab === null) {
      await this.$store.dispatch('campaign/updateECTab')
    }
    if (this.campaignId) {
      this.getSOW()
    } else {
      this.loading = true
    }
  },
  methods: {
    validateIO (rule, value, callback) {
      if (value == null || value.trim() === '') {
        callback(new Error(this.$t('请填写IO号')))
      } else {
        callback()
      }
    },
    hasDuplicates (a) {
      return _.uniq(a).length !== a.length
    },
    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.onConfirm()
        }
      })
    },
    async onConfirm () {
      const params = {
        task_id: this.taskId,
        sub_final_scope_id: this.subFinalScopeId,
        is_sow_io: this.ioForm.is_sow_io
      }
      if (this.ioForm.is_sow_io) {
        const res = _.flatten(this.ioForm.media_type.map(i => i.media_type_io))
        params.media_type_io = res.map(v => {
          return {
            io_file_path: v.io_file_path,
            media_type_id: v.media_type_id
          }
        })
        params.media_type_io_rel = res.map(i => {
          return i.media_type_io_rel.map(v => {
            return {
              io: getIONumber(i.media_type_category_name) + v.io
            }
          })
        })
        if (res.find(i => i.io_file_path == null)) {
          this.$message.error(this.$t('请填写必填项'))
          return
        }
        let validIO
        const arr = _.flatten(this.ioForm.media_type.map(i => i.media_type_io)).map(v => v.media_type_io_rel)
          .map(i => _.flatten(i))
          .map(o => {
            return o.map(j => {
              return j.io
            })
          })
        validIO = arr.some(i => this.hasDuplicates(i))
        if (validIO) {
          this.$message.error(this.$t('同一IO附件的IO号不能重复'))
          return
        }
      }
      this.loading = true
      try {
        const res = await axios.post('/management/ec/uploadIO', format4backend(params))
        this.ioForm = res
        await this.$store.dispatch('campaign/updateSubFinalScopeInfo')
        await this.$store.dispatch('campaign/updateECTab')
        this.loading = false
        this.$message.success(this.$t('提交成功'))
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    onCancel () {
      this.$router.push('/ec-campaign/overview')
    },
    uploadSuccess (res, item) {
      item.io_file_path = res.file_path
      item.io_file_name = res.file_name
      item.io_download_url = res.file_download_path
    },
    getSOW () {
      this.loading = true
      axios.get('/management/ec/getSOW', {
        params: {
          sub_final_scope_id: this.subFinalScopeId
        }
      })
        .then(res => {
          if (this.isOpen) {
            res.is_sow_io = 1
            res.media_type.map(v => {
              v.media_type_io = [{
                media_type_id: v.media_type_id,
                media_type_category_name: v.media_type_category_name,
                media_type_io_rel: [{
                  io: null
                }],
                io_file_path: null
              }]
              return v
            })
          }
          this.ioForm = res
          this.$forceUpdate()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    handleAddIO (i, index) {
      this.ioForm.media_type[i].media_type_io[index].media_type_io_rel.push({
        io: null
      })
    },
    handleAddIOFile (i) {
      this.ioForm.media_type[i].media_type_io.push(
        {
          io_file_path: null,
          media_type_id: this.ioForm.media_type[i].media_type_id,
          media_type_category_name: this.ioForm.media_type[i].media_type_category_name,
          media_type_io_rel: [
            {
              io: null
            }
          ]
        }
      )
    },
    handleClick () {
      this.$confirm(this.$t('选择暂无IO，项目将转为Bypass，请确定是否继续'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          this.ioForm.is_sow_io = 0
          this.onConfirm()
        })
    },
    getIONumberPrefix (name) {
      if (name == null) return 'KD'
      return getIONumber(name)
    },

    handleDeleteIO (parentIndex, index) {
      this.ioForm.media_type[parentIndex].media_type_io.splice(index, 1)
    },

    handleDeleteIONumber (parentIndex, index, idx) {
      this.ioForm.media_type[parentIndex].media_type_io[index].media_type_io_rel.splice(idx, 1)
    }
  }
}
</script>

<style lang='stylus'>
.io-info
  .card-title
    margin-top 24px
    margin-bottom 24px
    display flex
    justify-content space-between
    align-items center
  p
    font-size 16px
    color #2c3031
    margin 0
  .title-row
    margin-bottom 0
    margin-left 30px !important
  .content-row
    margin-left 30px !important
    margin-top 0 !important
  .add-io_btn
    margin-left 0
    padding-left 0
    margin-bottom 24px
    color $main !important
    border-color #ffffff !important
    background #ffffff  !important
    &:hover
      color $main !important
  .delete-io_btn
    color #f66c62
    margin-bottom 24px
    margin-right 5px
  .delete-io-num_btn
    margin-bottom 0 !important
  .media-form__container
    margin-top 24px
    .el-form-item
      .el-form-item__content
        display flex
    .io-input-form
      .el-form-item__error
        margin-left 15px
</style>
